module.exports = __webpack_public_path__ + "img/w6_04.3381e0ef.jpg";